import { Command } from 'commander';
import { ProjectInspectorService } from '../../services/project-inspector.service.js';
import { disableUpdateCheck } from '../../services/version-check.service.js';
import type { ProjectInspectionResult } from '../../types/project-inspector.types.js';

function formatList(values: string[]): string {
    return values.length > 0 ? values.join(', ') : 'Không phát hiện';
}

function printHumanResult(result: ProjectInspectionResult): void {
    console.log(`Trạng thái: ${result.status}`);
    console.log(`Primary package: ${result.primaryPackage ?? 'Chưa khởi tạo'}`);
    console.log(`Fingerprint: ${result.fingerprint.current}`);
    console.log(`Ngôn ngữ: ${formatList(result.signals.languages)}`);
    console.log(`Framework: ${formatList(result.signals.frameworks)}`);
    console.log(`Workspace: ${formatList(result.signals.workspaces)}`);
    console.log(`Lệnh dự án: ${formatList(result.signals.commands)}`);
    console.log(`Testing: ${formatList(result.signals.testing)}`);
    console.log(`Database: ${formatList(result.signals.database)}`);
    console.log(`Deployment: ${formatList(result.signals.deployment)}`);
    console.log(`IDE đang hoạt động: ${formatList(result.signals.activeIdes)}`);
    if (result.changedSignals.length > 0) {
        console.log(`Tín hiệu thay đổi: ${result.changedSignals.join(', ')}`);
    }
    if (result.degradedReasons.length > 0) {
        console.log(`Lý do degraded: ${result.degradedReasons.join(', ')}`);
    }
}

export function createProjectInspectCommand(): Command {
    return new Command('inspect')
        .description('Phân tích tín hiệu dự án cục bộ, không thay đổi file')
        .option('--json', 'Xuất kết quả dạng JSON')
        .action(async (options: { json?: boolean }, command: Command) => {
            disableUpdateCheck();
            const result = await new ProjectInspectorService().inspect();
            const rootOptions = command.parent?.parent?.opts<{ json?: boolean }>();
            if (options.json || rootOptions?.json) console.log(JSON.stringify(result, null, 2));
            else printHumanResult(result);
        });
}
